export default "__VITE_ASSET__Dl9g5DRA__"